import React from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Skeleton
} from '@mui/material';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import PIIConversionProtocolsPanel from './PIIConversionProtocolsPanel/PIIConversionProtocolsPanel';
import PIIHistoryHelp from './PIIHistoryHelp';

const PIIHistoryPage = () => {
  const { isLoggedIn, user, isLoading } = useAuth();
  const { t } = useTranslation();

  const renderSkeleton = () => (
    <>
      <Sidebar user={user} />
      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Skeleton variant="text" width={260} height={40} />
          <Skeleton variant="text" width={480} height={30} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={420} sx={{ borderRadius: 2 }} />
        </Paper>
      </Container>
    </>
  );

  if (!isLoggedIn || isLoading) return renderSkeleton();

  return (
    <>
      <Sidebar user={user} />

      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: 'text.primary' }}>
            {t('admin.pii.history', 'História anonymizácií')}
          </Typography>

          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
            {t('admin.pii.history_desc', 'Zobrazenie zaznamenaných anonymizácií súborov a textov.')}
          </Typography>

          <PIIHistoryHelp t={t} />

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PIIConversionProtocolsPanel />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default PIIHistoryPage;